module.exports = __webpack_public_path__ + "img/Global_Compact_AntiCorruption.93677326.svg";